import { render, staticRenderFns } from "./ProductAmountToBeOrderedFilter.vue?vue&type=template&id=2a2723aa"
import script from "./ProductAmountToBeOrderedFilter.vue?vue&type=script&lang=ts"
export * from "./ProductAmountToBeOrderedFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a2723aa')) {
      api.createRecord('2a2723aa', component.options)
    } else {
      api.reload('2a2723aa', component.options)
    }
    module.hot.accept("./ProductAmountToBeOrderedFilter.vue?vue&type=template&id=2a2723aa", function () {
      api.rerender('2a2723aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductAmountToBeOrderedFilter.vue"
export default component.exports